const _temp0 = require("./luma_1.webp");
const _temp1 = require("./main.webp");
module.exports = {
  "luma_1": _temp0,
  "main": _temp1
}